import {ErrorMessage} from 'formik';
import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import clock_icon from '../../../../../../../../../assets/job_postings/icons/clock-icon.png';
import {EmpionMultiSelect} from '../../../../../../../../../components/EmpionMultiSelect/EmpionMultiSelect';
import {SUPPORTED_EMPLOYMENT_TYPES} from '../../../../../../../../../lib/constants';

interface HardFactsFieldEmploymentType {
  formik: any;
}

export const HardFactsFieldsEmploymentType = ({formik}: HardFactsFieldEmploymentType) => {
  const {t} = useTranslation();

  const employmentTypeOptions = SUPPORTED_EMPLOYMENT_TYPES.map((type) => ({
    id: type.id,
    label: t(`shared.employmentTypes.${type.id}`),
  }));

  const initialValues = () => {
    if (!formik.values.employmentType || formik.values.employmentType.length === 0) {
      return [];
    }
    return employmentTypeOptions
      .filter((option) => formik.values.employmentType.includes(option.id))
      .map((option) => option.label);
  };

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <Box component='img' src={clock_icon} alt='clock_icon' />
      <Box width={'100%'}>
        <EmpionMultiSelect
          size='small'
          label={`${t('companyJobPostings.newJobDialog.formLabels.employmentType')}*`}
          options={employmentTypeOptions}
          onChange={(selected) => formik.setFieldValue('employmentType', selected)}
          displayDefaultOptions={initialValues()}
        />
        <Typography variant='body2' color='error'>
          <ErrorMessage name='employmentType' component='span' />
        </Typography>
      </Box>
    </Grid>
  );
};
